// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"94":"7add1fe5","304":"1b7296c6","559":"367c51a4","708":"85be04f4","809":"1b7296c6","836":"1b7296c6","971":"367c51a4"}[chunkId] + ".chunk.css";
};